import {FloatingFocusManager as FloatingUIFocusManager, FloatingPortal} from '@floating-ui/react'
import {useFloatingContext} from '../context'
import {useLegacyModalContext} from '~/components/legacy_modal/modal_context'
import {useLayoutEffect, useState} from 'react'

export const FloatingFocusManager = ({children, ...rest}) => {
	const {modalRef} = useLegacyModalContext() // specifies the root node the portal container will be appended to if we are inside a modal
	const {context, isNested} = useFloatingContext()
	const [root, setRoot] = useState(null)

	useLayoutEffect(() => {
		if (modalRef?.current) {
			setRoot(modalRef.current)
			return
		}

		// Legacy modal and new Ark modal do not pass refs, use classname selectors instead
		// Not a problem as long as we don't open multiple modals at the same time.
		const el = document.querySelector('.ant-modal-body') || document.querySelector('.modal-content')

		setRoot(el || document.body)
	}, [modalRef])

	// ignore initial focus for nested items, otherwise keep default tabbable index as specified by the `order`
	const initialFocus = isNested ? -1 : 0

	return (
		<FloatingPortal root={root}>
			<FloatingUIFocusManager modal={false} {...rest} context={context} initialFocus={initialFocus} returnFocus={!isNested}>
				{children}
			</FloatingUIFocusManager>
		</FloatingPortal>
	)
}
